import {
    request,
    requestPublic
} from './request.js'
// 文章分类
// 获取文章分类列表
export function getCategoryPag() {
    return request({
        url: '/api2/ZsbSiteAdmin/Category/CategoryPagination',
        method: 'get',
    })
}
// 获取文章分类详情
export function getCategory(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Category/GetCategory',
        method: 'get',
        params: {
            id: id
        }
    })
}
// 添加分类
export function addCategory(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Category/AddCategory',
        method: 'post',
        data: data
    })
}
// 修改分类
export function modifyCategory(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Category/ModifyCategory',
        method: 'post',
        data: data
    })
}
// 删除分类
export function removeCategory(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Category/RemoveCategory?id=' + id,
        method: 'post',
    })
}
// 获取所有顶级分类
export function getFirstLevel() {
    return request({
        url: '/api2/ZsbSiteAdmin/Category/FirstLevelCategory',
        method: 'get',
    })
}


// 发布指定栏目页
export function PublishCategoryHtml(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/HtmlRelease/PublishCategoryHtml?id=' + id,
        method: 'post',
    })
}

// 批量更新文章上下架
export function UpdateArticleIsOut(articleIds,isOut) {
    return request({
        url: '/api2/ZsbSiteAdmin/Article/UpdateArticleIsOut',
        method: 'post',
        data: {
            isOut:isOut,
            articleIds:articleIds
        }
    })
}